import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { categoryName, formatCount, formatDate } from "@/utils/articles";

interface PopularSectionProps {
  items: Article[];
}

export default function PopularSection({ items }: PopularSectionProps) {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs tracking-[0.3em] text-secondary-600 mb-2">TRENDING</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热门推荐
            </h2>
          </div>
          <p className="hidden sm:block text-sm text-foreground-500">
            按阅读与收藏综合排序
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((a, i) => (
            <Link
              key={a.id}
              to={`/detail/${a.id}`}
              className="group flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-300 transition-colors"
            >
              <div className="relative w-full aspect-[8/5] overflow-hidden bg-background-200">
                <img
                  src={a.cover}
                  alt={a.title}
                  title={`${a.title} - 理论电影`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-bold">
                  NO.{i + 1}
                </span>
              </div>
              <div className="flex-1 flex flex-col p-4">
                <span className="text-xs text-secondary-700 font-medium mb-2">
                  {categoryName(a.category)}
                </span>
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 mb-3 line-clamp-2 group-hover:text-secondary-700 transition-colors">
                  {a.title}
                </h3>
                <div className="mt-auto flex items-center justify-between text-xs text-foreground-500">
                  <span>{formatDate(a.date)}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {formatCount(a.views)}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}